import * as React from 'react'

import About from './About'
import Product from './Product'
import References from './References'
import Contacts from './Contacts'
import { recordModalView } from '../../../analytics/index'
import { RouteComponentProps, withRouter } from 'react-router'

type FeatureRouterProps = {
  openFeedback: () => void
} & RouteComponentProps<{}>

const FeatureRouter: React.SFC<FeatureRouterProps> = props => {
  switch (props.location.hash) {
    case '#product':
      recordModalView('product')
      return <Product />

    case '#about':
      recordModalView('about')
      return <About />

    case '#references':
      recordModalView('references')
      return <References />

    case '#contacts':
      recordModalView('contacts')
      return <Contacts openFeedback={props.openFeedback} />

    default:
      return null
  }
}

export default withRouter<FeatureRouterProps>(FeatureRouter)



// WEBPACK FOOTER //
// ./src/Components/Layout/Features/FeatureRouter.tsx